/* import __COLOCATED_TEMPLATE__ from './credit-card-shipping-banner.hbs'; */
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Component from '@glimmer/component';
import { addBusinessDate, getStartOfDay } from '@banking/ui/utils/date-math';
const EXPECTED_DELIVERY_BUSINESS_DAYS = 10;
export default class BankingLaunchpadCreditCardShippingBanner extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "tagName", '');
    _defineProperty(this, "arrivalDate", addBusinessDate(this.args.cardIssuedDate, EXPECTED_DELIVERY_BUSINESS_DAYS));
  }
  get showActivationAction() {
    const fourBusinessDaysAway = addBusinessDate(this.args.cardIssuedDate, 4);
    const now = getStartOfDay(new Date());
    return now.getTime() > fourBusinessDaysAway.getTime();
  }
}